import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { MappedName } from '@pubstack/common/src/analytics/query'
import { CurrencySymbol } from '@pubstack/common/src/currency'
import { Color } from '~/assets/style/colors'
import { IconName } from '~/components/Icon'
import { adxImpressionRevenue, hbImpressionRevenue, openBiddingImpressionRevenue, serverSideImpressionRevenue } from '~/modules/analytics/common/formulas'
import { Context } from '~/state'
import { WithClassName } from '~/types/utils'

export type OverviewRevenueChartProps = WithClassName & {
  context: Context
  title: string
  icon: IconName
  currencySymbol: CurrencySymbol
  dimension: Dimension
  dimensions: Dimension[]
  revenueDisplayThreshold: number
  moreUri?: string
  onMore?: (dimension: Dimension) => void
  onRevenueChartSelect: (name: MappedName) => void
}

export type RevenueDataConfig = {
  name: string
  color: Color
  formula: typeof hbImpressionRevenue | typeof adxImpressionRevenue | typeof openBiddingImpressionRevenue | typeof serverSideImpressionRevenue
}

export const getIconFromDimension = (dimension: Dimension) => {
  const icons: { [key in Dimension]?: IconName } = {
    bidder: 'bidder',
    tagId: 'site',
    country: 'position',
    device: 'device',
    adUnit: 'picture_in_picture',
    size: 'size',
  }

  return icons[dimension] ?? 'warning'
}

export const getTitleFromDimension = (dimension: Dimension) => {
  const titles: { [key in Dimension]?: string } = {
    bidder: 'bidders',
    tagId: 'sites',
    country: 'countries',
    device: 'devices',
    adUnit: 'ad units',
    size: 'sizes',
  }

  return titles[dimension] ?? ''
}

export const getUriForMoreFromDimension = (dimension: Dimension) => {
  const titles: { [key in Dimension]?: string } = {
    bidder: '/analytics/bidders/',
    tagId: '/analytics/sites/',
  }

  return titles[dimension]
}

export const getUriForMoreFromDimensionServerSide = (dimension: Dimension) => {
  const titles: { [key in Dimension]?: string } = {
    bidder: '/analytics/server-side?dimension=bidder',
    tagId: '/analytics/server-side?dimension=tagId',
  }

  return titles[dimension]
}
